<template>
<form @submit.prevent="updateProfile">
    <card>
        <h2 slot="header" class="card-title">{{$t('page_user.profile__title')}}</h2>
        <div class="row">
            <div class="col-lg-3">
                <base-input type="text" name="name" v-validate="'required'" :error="getError('name')" :label="$t('page_user.profile__name')" :placeholder="$t('page_user.profile__name')" v-model="model.profile.name">
                </base-input>
                <base-input type="text" name="organization" v-validate="'required'" :error="getError('organization')" :label="$t('page_user.profile__organization')" :placeholder="$t('page_user.profile__organization')" v-model="model.profile.organization">
                </base-input>
                <input-phone v-model="model.profile.phone" name="phone" v-validate="'required'" :error="getError('phone')" :label="$t('page_user.profile__telephone')" :placeholder="$t('page_user.profile__telephone')"></input-phone>
                <base-input type="text" disabled v-model="model.profile.email" :label="$t('page_user.profile__email')"></base-input>
                <div v-if="loggedUser.role !== UserRoles.ADMIN && (model.profile.role === UserRoles.EVALUATOR || model.profile.role === UserRoles.REGIONAL_ADMIN)" class="mt-4">
                    <p v-if="model.profile.role">
                        Your role is: <strong>{{model.profile.role.replace('_', ' ')}}</strong>
                    </p>
                    <div v-if="model.regions.length">
                        <p>Your regions are:</p>
                        <ul>
                            <li v-for="region in model.regions" :key="region.regionId">
                                <strong>{{region.name}}</strong>
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-if="loggedUser.role === UserRoles.APPLICANT || loggedUser.role === UserRoles.ADMIN" class="form-group">
                    <label for="regionSelect">{{$t('page_user.profile__region')}}</label>
                    <select class="form-control" @change="setRegion" name="region" id="regionSelect" :error="getError('region')" v-validate="'required'">
                        <option value="" selected="selected">{{$t('general.please_select')}}</option>
                        <option :value="region.regionId" :selected="model.fields.regionId === region.regionId" v-for="region in regions" :key="region.regionId">{{region.code}} - {{region.name}}</option>
                    </select>
                    <label v-if="getError('region')" class="error text-danger">{{getError('region')}}</label>
                </div>
                <div v-if="loggedUser.role === UserRoles.ADMIN">
                    <div class="form-group">
                        <label for="roleSelect">{{$t('page_user.profile__role')}}</label>
                        <select class="form-control" :disabled="loggedUser.role !== UserRoles.ADMIN" v-model="model.profile.role" name="role" :error="getError('role')" v-validate="'required'">
                            <option :value="role" :selected="model.profile.role === role" v-for="role in UserRoles" :key="role">{{role.replace('_', ' ')}}</option>
                        </select>
                    </div>
                </div>

                <div v-if="loggedUser.role === UserRoles.ADMIN && model.profile.role === UserRoles.EVALUATOR" class="form-group">
                    <label for="evaluators">{{ $t('page_user.profile__evaluator') }}</label>
                    <select class="form-control" @change="setEvaluator" name="evaluator" id="evaluator">
                        <option value="" selected="selected">{{ $t('general.please_select') }}</option>
                        <option value="none" :selected="model.fields.evaluator === 'none'">{{ $t('page_user.profile__evaluator_none') }}</option>
                        <option value="1" :selected="model.fields.evaluator == 1">Evaluator 1</option>
                        <option value="2" :selected="model.fields.evaluator == 2">Evaluator 2</option>
                    </select>
                </div>

                <div class="mb-5"></div>
            </div>
        </div>
        <base-button v-if="isEditable" native-type="submit" type="primary" size="lg" class="btn-fill">
            Save
        </base-button>
    </card>
</form>
</template>
<script>
import {
    UserService,
    UserRoles,
    RegionService,
    LocalizationService
} from '@/services';
import InputPhone from '@/components/InputPhone';
import {
    BaseRadio
} from 'src/components';
import Multiselect from 'vue-multiselect';

export default {
    components: {
        InputPhone,
        Multiselect,
        BaseRadio
    },
    data() {
        return {
            UserRoles,
            regions: [],
            countries: [],
            value: '',
            initialized: false,
            model: {
                access_type: 'countries',
                profile: {},
                fields: {},
                regions: [],
                countries: []
            }
        };
    },
    props: {
        isEditable: {
            type: Boolean,
            default: true
        },
        userId: {
            type: [Number, String],
            default: null
        }
    },
    computed: {
        loggedUser() {
            return this.$store.getters['Auth/loggedUser'];
        },
        countriesByRegions() {
            let vm = this;
            if (!vm.initialized) {
                return [];
            }
            let countries = [];

            if (vm.model.regions) {
                vm.model.regions.forEach(function(region) {
                    let regionCountries = vm.countriesByRegion(region.regionId);
                    countries = countries.concat(regionCountries);
                })
            }

            countries = countries.sort(function(a, b) {
                var textA = a.name.toLowerCase();
                var textB = b.name.toLowerCase();

                return textA.localeCompare(textB);
            })

            if (vm.model.countries) {
                let removed_countries = [];
                vm.model.countries.forEach(function(country) {
                    let filteredCountry = countries.filter((_country) => {
                        return _country.countryId === country.countryId;
                    });

                    if (!filteredCountry.length) {
                        removed_countries.push(country);
                    }
                })

                removed_countries.forEach(function(country) {
                    let countryIndex = vm.model.countries.indexOf(country);
                    if (countryIndex !== -1) {
                        vm.model.countries.splice(countryIndex, 1);
                    }
                })
            }

            return countries;
        }
    },
    async beforeMount() {
        let loader = this.$loading.show();
        let vm = this;

        var promises = [];

        var profileRequest;
        if (this.userId) {
            profileRequest = UserService.getUserProfileData(this.userId);
        } else {
            profileRequest = UserService.getProfileData();
        }

        let promiseUser = profileRequest.then((response) => {
            this.model = { ...this.model,
                ...response.data
            };
            if (!this.model.profile) {
                this.model.profile = {};
            }
            if (!this.model.fields) {
                this.model.fields = {};
            }
        })

        let promiseRegion = RegionService.getRegionsWithCountries().then(function(response) {
            vm.regions = response.data;
        })

        promises.push(promiseUser);
        promises.push(promiseRegion);

        await Promise.all(promises);

        vm.initialized = true;
        loader.hide();
    },
    methods: {
        countriesByRegion: function(regionId) {
            let countries = [];
            let region = this.regions.filter((region) => {
                return region.regionId === regionId;
            });
            if (region[0] !== undefined && region[0].countries !== undefined && region[0].countries.length) {
                countries = region[0].countries;
            }
            return countries;
        },
        setRegion(event) {
            this.model.fields.regionId = parseInt(event.target.value);
            this.model.fields.countryId = [];
        },
        setCountry(event) {
            this.model.fields.countryId = parseInt(event.target.value);
        },
        setEvaluator(event)
        {
            this.model.fields.evaluator = event.target.value;
        },
        async updateProfile() {
            let vm = this;
            let isValidForm;

            if (this.loggedUser.id === this.model.profile.id) {
                isValidForm = await this.$validator.validateAll();
            } else {
                isValidForm = true;
            }

            if (isValidForm) {
                let loader = this.$loading.show();

                var updateRequest;
                if (this.userId) {
                    updateRequest = UserService.updateUserProfileData(this.model, this.userId);
                } else {
                    updateRequest = UserService.updateProfileData(this.model);
                }

                await updateRequest.then(() => {
                    this.$store.dispatch('Auth/init');
                    LocalizationService.init();

                }).catch(() => {

                });

                loader.hide();
            }
        },
        getError: function(fieldName) {
            return this.errors.first(fieldName);
        }
    }
};
</script>
<style scoped lang="scss">
.radio-component {
    margin-bottom: 0.2rem !important;
}
</style>
